
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-importer-url',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './importer-url.component.html',
  styleUrl: './importer-url.component.css'
})
export class ImporterUrlComponent {
  @ViewChild('responseModal') responseModal: any;
  fileTypes: string[] = ['KML Url', 'GeoJSON Url', 'CSV Url'];
  selectedFileType = this.fileTypes[0];
  fileUrl: string = '';
  responseMessage: string = '';

  @Output() fileImported = new EventEmitter<{ type: string; url: string }>();
  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal
  ) {}

  onImport() {
    if (this.fileUrl) {
      this.fileImported.emit({
        type: this.selectedFileType,
        url: this.fileUrl.trim(),
      });
      this.activeModal.close({
        type: this.selectedFileType,
        url: this.fileUrl.trim(),
      });
    }
  }

  closeDialog() {
    this.activeModal.dismiss('Cross click');
  }

  onCancel() {
    this.activeModal.dismiss('Cancel');
  }

  showResponseModal() {
    this.modalService.open(this.responseModal, {
      windowClass: 'bottom-left-modal',
      backdrop: 'static',
      keyboard: false,
      backdropClass: 'transparent-backdrop'
    });
  }
}
